var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommonError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 240L192 240L192 0L48 -6.46475e-09L48 240Z",
    fill: "#588AF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120 14C121.105 14 122 13.1046 122 12C122 10.8954 121.105 10 120 10C118.895 10 118 10.8954 118 12C118 13.1046 118.895 14 120 14Z",
    fill: "#0A0B0D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128 226H112V230H128V226Z",
    fill: "#0A0B0D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48 216L192 216L192 24L48 24L48 216Z",
    fill: "#464B55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.324 190C119.102 190 134.324 174.778 134.324 156C134.324 137.222 119.102 122 100.324 122C81.5465 122 66.3242 137.222 66.3242 156C66.3242 174.778 81.5465 190 100.324 190ZM100.324 192C120.206 192 136.324 175.882 136.324 156C136.324 136.118 120.206 120 100.324 120C80.442 120 64.3242 136.118 64.3242 156C64.3242 175.882 80.442 192 100.324 192Z",
    fill: "#0A0B0D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.253 90C184.253 105.464 171.717 118 156.253 118C140.789 118 128.253 105.464 128.253 90C128.253 74.536 140.789 62 156.253 62C171.717 62 184.253 74.536 184.253 90Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2529 60C96.2529 71.0457 87.2986 80 76.2529 80C65.2072 80 56.2529 71.0457 56.2529 60C56.2529 48.9543 65.2072 40 76.2529 40C87.2986 40 96.2529 48.9543 96.2529 60Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M128.324 156C128.324 171.464 115.788 184 100.324 184C84.8602 184 72.3242 171.464 72.3242 156C72.3242 140.536 84.8602 128 100.324 128C115.788 128 128.324 140.536 128.324 156Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.324 182C114.684 182 126.324 170.359 126.324 156C126.324 141.641 114.684 130 100.324 130C85.9648 130 74.3242 141.641 74.3242 156C74.3242 170.359 85.9648 182 100.324 182ZM100.324 184C115.788 184 128.324 171.464 128.324 156C128.324 140.536 115.788 128 100.324 128C84.8602 128 72.3242 140.536 72.3242 156C72.3242 171.464 84.8602 184 100.324 184Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.253 108C166.194 108 174.253 99.9411 174.253 90C174.253 80.0589 166.194 72 156.253 72C146.312 72 138.253 80.0589 138.253 90C138.253 99.9411 146.312 108 156.253 108ZM156.253 110C167.299 110 176.253 101.046 176.253 90C176.253 78.9543 167.299 70 156.253 70C145.207 70 136.253 78.9543 136.253 90C136.253 101.046 145.207 110 156.253 110Z",
    fill: "#0A0B0D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.2529 60C90.2529 67.732 83.9849 74 76.2529 74C68.5209 74 62.2529 67.732 62.2529 60C62.2529 52.268 68.5209 46 76.2529 46C83.9849 46 90.2529 52.268 90.2529 60ZM76.2529 72C82.8803 72 88.2529 66.6274 88.2529 60C88.2529 53.3726 82.8803 48 76.2529 48C69.6255 48 64.2529 53.3726 64.2529 60C64.2529 66.6274 69.6255 72 76.2529 72Z",
    fill: "#0A0B0D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2529 60C80.2529 62.2091 78.4621 64 76.2529 64C74.0438 64 72.2529 62.2091 72.2529 60C72.2529 57.7909 74.0438 56 76.2529 56C78.4621 56 80.2529 57.7909 80.2529 60Z",
    fill: "#464B55"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.324 156C112.324 162.627 106.952 168 100.324 168C93.6968 168 88.3242 162.627 88.3242 156C88.3242 149.373 93.6968 144 100.324 144C106.952 144 112.324 149.373 112.324 156Z",
    fill: "#464B55"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.325 156C104.325 158.209 102.534 160 100.324 160C98.1152 160 96.3242 158.209 96.3242 156C96.3242 153.791 98.1152 152 100.324 152C102.534 152 104.325 153.791 104.325 156Z",
    fill: "#464B55"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.324 153C98.6675 153 97.3242 154.343 97.3242 156C97.3242 157.657 98.6675 159 100.324 159C101.981 159 103.325 157.657 103.325 156C103.325 154.343 101.981 153 100.324 153ZM95.3242 156C95.3242 153.239 97.5629 151 100.324 151C103.086 151 105.325 153.239 105.325 156C105.325 158.762 103.086 161 100.324 161C97.5629 161 95.3242 158.762 95.3242 156Z",
    fill: "#0A0B0D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M160.753 90C160.753 92.2091 158.962 94 156.753 94C154.544 94 152.753 92.2091 152.753 90C152.753 87.7909 154.544 86 156.753 86C158.962 86 160.753 87.7909 160.753 90Z",
    fill: "#464B55"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.753 87C155.096 87 153.753 88.3431 153.753 90C153.753 91.6569 155.096 93 156.753 93C158.41 93 159.753 91.6569 159.753 90C159.753 88.3431 158.41 87 156.753 87ZM151.753 90C151.753 87.2386 153.992 85 156.753 85C159.514 85 161.753 87.2386 161.753 90C161.753 92.7614 159.514 95 156.753 95C153.992 95 151.753 92.7614 151.753 90Z",
    fill: "#0A0B0D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6449 53.5485L131.145 137.548L129.36 138.451L86.8604 54.4514L88.6449 53.5485Z",
    fill: "#0A0B0D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.118 82.0021L98.6177 153.502L96.8879 152.498L138.388 80.9981L140.118 82.0021Z",
    fill: "#0A0B0D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.389 106.771L104.389 158.771L103.116 157.229L166.116 105.229L167.389 106.771Z",
    fill: "#0A0B0D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.252 59.4798L66.252 157.48L64.2524 157.521L62.2524 59.5206L64.252 59.4798Z",
    fill: "#0A0B0D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M48 1.72381e-09L0 0L-8.61906e-10 24L48 24L48 1.72381e-09Z",
    fill: "#464B55"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M48 216L0 216L-8.61906e-10 240L48 240L48 216Z",
    fill: "#464B55"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M240 1.72381e-09L192 0L192 24L240 24L240 1.72381e-09Z",
    fill: "#464B55"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M240 216L192 216L192 240L240 240L240 216Z",
    fill: "#464B55"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonError);
export default __webpack_public_path__ + "static/media/common-error.186a49212174cf7f938b82d7407fb8b4.svg";
export { ForwardRef as ReactComponent };